var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLastDayAlerts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 52,
    fill: "#ACACAC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_56220)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1050,
    transform: "translate(-1330 -103)",
    fill: "#F4F7FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.5391,
    width: 52.4507,
    height: 51.8678,
    rx: 25.9339,
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_86_56220)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1299,
    y: -23,
    width: 1521,
    height: 91,
    rx: 9.94788,
    fill: "#FEFEFF"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.539062,
    width: 52.4507,
    height: 51.8678,
    rx: 25.9339,
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4999 13C31.9885 13 35.661 16.7984 35.661 21.4675L35.6611 27.093H38V34.262H31.8293C31.6602 35.3045 31.1386 36.2508 30.3564 36.9359C29.5741 37.6201 28.5818 37.9969 27.5547 38H27.4453C26.4182 37.9969 25.4259 37.6201 24.6436 36.9359C23.8614 36.2508 23.3399 35.3046 23.1707 34.262H17V27.093H19.3389V21.4675C19.3389 16.7984 23.0113 13 27.4999 13ZM27.4997 14.6388C23.8889 14.6388 20.9311 17.702 20.9311 21.4677V27.0932H34.0684V21.4677C34.0684 17.702 31.1106 14.6388 27.4997 14.6388ZM27.5543 36.3615H27.4448C26.1977 36.3707 25.1049 35.5053 24.7955 34.262H30.2039C29.8944 35.5053 28.8016 36.3707 27.5546 36.3615H27.5543ZM18.5919 32.6237H36.4071V28.7319H18.5919V32.6237Z",
    fill: "#252525"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_86_56220",
    x: -1301,
    y: -23,
    width: 1525,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.307813 0 0 0 0 0.326577 0 0 0 0 0.375 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_86_56220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_86_56220",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_56220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1050,
    fill: "white",
    transform: "translate(-1330 -103)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastDayAlerts);
export default __webpack_public_path__ + "static/media/last-day-alerts.df4e505d7670ad499b301ca78860cb52.svg";
export { ForwardRef as ReactComponent };